export const normalizeReviewDepartment = (value = "") => String(value)
  .toLowerCase().replace(/&/g, "and").replace(/\bdepartment\b/g, "")
  .replace(/\s+/g, " ").trim();

export const getReviewRowKey = (row) => `${row.permit_id}:${normalizeReviewDepartment(row.review_department_name || row.review_department || row.department)}`;

export const hasSavedReviewDetails = (approval) => Boolean(
  String(approval?.observations || "").trim() ||
  (approval?.inputs || []).some(input => input.field_type === "boolean"
    ? [true, false, "true", "false"].includes(input.field_value)
    : input.field_value !== null && input.field_value !== undefined && String(input.field_value).trim() !== "")
);

const allowed = value => [true, 1, "1", "true"].includes(value);

export function resolveDepartmentReview(row, approvals = [], pending = []) {
  const department = normalizeReviewDepartment(row.review_department_name || row.review_department || row.department);
  const observation = approvals.find(item => normalizeReviewDepartment(item.department_name) === department);
  if (observation) return observation;
  const assignment = pending.find(item => String(item.permit_id) === String(row.permit_id) &&
    normalizeReviewDepartment(item.review_department || item.review_department_name || item.department) === department);
  return assignment ? {
    ...assignment,
    department_id: assignment.review_department_id || assignment.department_id,
    can_approve: assignment.can_approve ?? true,
    can_reject: assignment.can_reject ?? true,
    inputs: [], observations: "",
  } : null;
}

export function getReviewActionState(approval, { loading = false, error = false } = {}) {
  const approved = approval?.approval_status === "Approved";
  const saved = hasSavedReviewDetails(approval);
  const available = !loading && !error && Boolean(approval?.department_id) && !approved;
  const commonReason = loading ? "Checking review permissions…" : error
    ? "Unable to check review permissions. Refresh the list to retry."
    : approved ? "This department review is already approved." : "";
  return {
    visible: loading || error || (!approved && Boolean(approval?.department_id) && (allowed(approval?.can_approve) || allowed(approval?.can_reject))),
    canApprove: available && allowed(approval?.can_approve) && saved,
    canReject: available && allowed(approval?.can_reject),
    approveReason: commonReason || (!allowed(approval?.can_approve) ? "You do not have permission to approve this permit." : !saved ? "Save department details first." : "Approve department review"),
    rejectReason: commonReason || (!allowed(approval?.can_reject) ? "You do not have permission to reject this permit." : "Reject department review"),
  };
}
